import { render } from "./UploadDocumentos.vue?vue&type=template&id=42e4b17a"
import script from "./UploadDocumentos.vue?vue&type=script&lang=js"
export * from "./UploadDocumentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__